<div class="mat-typography notice-dialog">

  @if (config?.showClose) {
    <button
      mat-dialog-close
      class="notice-dialog__close-button close-button"
      title="Close Dialog"
      aria-label="Close Dialog"
      >
      <span
        class="notice-dialog__close-text close-text"
        aria-hidden="true"
        >
        &times;
      </span>
    </button>
  }

  <mat-dialog-content class="notice-dialog__mat-content">

    <!-- Figure and Title. Allow either one individually or both. -->
    <div class="notice-dialog__media notice-dialog__title-media"
        [ngClass]="{
          'notice-dialog__media--has-gutter': config?.icon || config?.image,
          'notice-dialog__media--has-body': config?.text?.title
        }">
      <div class="notice-dialog__media-gutter">

        @if (config?.icon) {
          <mat-icon
            class="notice-dialog__figure"
            [color]="config?.icon?.color || 'softer'"
            >
            {{config.icon.name}}
          </mat-icon>
        }

        @if (config?.image) {
          <img
            class="notice-dialog__figure"
            [src]="config.image.url"
            [alt]="config.image.alt"
            >
        }

      </div>
      <div class="notice-dialog__media-body">
        <h2 mat-dialog-title class="notice-dialog__title mat-title mat-title">{{ config?.text?.title }}</h2>
      </div>
    </div>

    <!-- Body is always visible, but only show the gutter if we have a title and icon. -->
    <div
      class="notice-dialog__media notice-dialog__main-media notice-dialog__media--has-body"
      [ngClass]="{'notice-dialog__media--has-gutter': ((config?.icon || config?.image) && config?.text?.title) }"
      >
      <div class="notice-dialog__media-gutter"></div>
      <div class="notice-dialog__media-body mat-of-body-small text-softer">
        <div [innerHtml]="config?.text?.body || 'Thank you'"></div>
      </div>
    </div>
  </mat-dialog-content>

  @if (config?.controls?.length > 0) {
    <mat-dialog-actions>
      <!-- Body is always visible, but only show the gutter if we have a title and icon. -->
      <div
        class="notice-dialog__media notice-dialog__actions-media notice-dialog__media--has-body"
        [ngClass]="{'notice-dialog__media--has-gutter': ((config?.icon || config?.image) && config?.text?.title) }"
        >
        <div class="notice-dialog__media-gutter"></div>
        <div class="notice-dialog__media-body">
          @for (control of config.controls; track control) {
            <button
              mat-button
              [ngClass]="(control && control.class) ? 'notice-dialog__button ' + control.class : 'notice-dialog__button mat-button mat-primary'"
              (click)="onButtonPress($event, control.callbackFn)"
            >{{ control?.text }}</button>
          }
        </div>
      </div>
    </mat-dialog-actions>
  }
</div>
